import script from "./web-search-page.vue?vue&type=script&setup=true&lang=js"
export * from "./web-search-page.vue?vue&type=script&setup=true&lang=js"

import "./web-search-page.vue?vue&type=style&index=0&id=2bf1d6bc&lang=scss"

const __exports__ = script;

export default __exports__